import { computed, getCurrentInstance, reactive } from '@nuxtjs/composition-api';
export interface EnumItem {
  key?: string | number;
  value: any;
  options?: { [key: string]: any };
}
export enum EnumKeys {
  Prefecture = 'prefecture',
  PrefectureGroup = 'prefecture_group',
  PrefectureGroupWithOnline = 'prefecture_group_with_online',
  Gender = 'gender',
  GraduationStatus = 'graduation_status',
  LicenseStatus = 'license_status',
  PrivacySetting = 'privacy_setting',
  EmploymentType = 'employment_type',
  JobSort = 'job_sort',
  EventSort = 'event_sort',
}
export default function useEnums(type: EnumKeys) {
  const enums = reactive<{ [key: string]: EnumItem[] }>({});
  const enumList = computed(() => {
    if (!enums[type]) {
      const vm = getCurrentInstance()?.proxy;
      const values = vm?.$i18n.t(`enums.${type}`);
      const list: EnumItem[] = [];
      if (typeof values === 'string') {
        list.push({
          key: values,
          value: values,
        });
      } else {
        for (const key in values) {
          const convertedKey = convertEnumKey(type, key);
          if (typeof values[key] === 'string') {
            list.push({
              key: convertedKey,
              value: values[key],
            });
          } else {
            list.push({
              key: convertedKey,
              value: values[key].label,
              options: values[key],
            });
          }
        }
      }
      enums[type] = list;
    }
    return enums[type];
  });
  const getLabel = (value?: string | number) => {
    return enumList.value?.find((item) => item.key === value)?.value;
  };
  return { enums: enumList.value!, getLabel };
}

const convertEnumKey = (type: EnumKeys, key: any) => {
  const str = String(key);
  switch (type) {
    case 'prefecture':
      return str.length === 1 ? `0${str}` : str;
    default:
      return key;
  }
};
